export default "__VITE_ASSET__DMRJFgjm__"